import "./Gateway.css";
import {Divider } from "antd";
import { Form } from "antd";
import { useEffect, useState, Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import React from 'react';
import { t} from "i18next";
import Selector from "components/Selector/Selector";
import Spinner from "components/Spinner/Spinner";
import TextInput from "components/Inputs/TextInput/TextInput";
import PrimaryButton from "components/Buttons/PrimaryButton/PrimaryButton";
import centralApi from "services/centralApi";
import { API_ENDPOINTS } from "utils/constants";
import { getToken } from "redux/features/app/authTokenSlice";
import { CampaignChannelTypeEnum, } from "utils/enums"
import useMessage from "hooks/useMessage";

const Gateway: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch: any = useDispatch();
  const {showError,showSuccess}=useMessage()

  const loginUser = useSelector((state: any) => state.loginUser);
  const activeApp = useSelector((state: any) => state.activeApp);
  const authToken = useSelector((state: any) => state.authToken.token);


  const features = useSelector((state: any) => state.featuresSetting.data);

  const channelStatus = features[0]?.channel_status;
  const gatewayConfig = features[0]?.gatewayConfig;

  const [channel , setChannel] = useState<string>("" );
  const appId = activeApp.appId;
  const api_key = loginUser.data.api_key;
  
 /**
   * 
   * @param e will be an event and e.target.value will be a number string
   * @param fieldName will be the key of and object where we are setting the values
   * @returns key with number value
   */

  // Memoize the options generation for performance
// Memoize the options generation for performance
const channelOptions = useMemo(() => {
  // Pre-generate a map of campaign channel enum types for easier access
  const allChannels = Object.values(CampaignChannelTypeEnum);

  // If channel_status is undefined, return all enum channels except "ALL"
  if (!channelStatus) {
    return allChannels
      .filter((key) => key !== CampaignChannelTypeEnum.ALL) // Exclude "ALL"
      .map((key) => ({
        value: key,
        label: key,
      }));
  }

  // Otherwise, filter the channels where the status is true, excluding "ALL"
  return allChannels
    .filter((key) => key !== CampaignChannelTypeEnum.ALL && (channelStatus[key] === true)) // Exclude "ALL"
    .map((key) => ({
      value: key,
      label: key,
    }));
}, [channelStatus]);

  const onFormSubmit = async(values:any) => {

    const payload = {
      args: JSON.stringify({
        gatewayConfig: {
          [channel]: {
            expiration: parseInt(values.expiration),
            endpoint:values.endpoint,
            username :values?.username ,
            authkey : values?.authkey,
            field : values?.field,
           
          }
        },
        app_id: appId
      }),
      gateway: true,
      app_id: appId,
      api_key: api_key,
      authToken
    };
    

    await updateGatewaySettings(payload);
    dispatch(getToken())
    
};

  async function updateGatewaySettings(formData: any) {
    const url: string = API_ENDPOINTS.UPDATE_GCM_KEYS;

    try {
      setLoading(true);
      await centralApi("POST", url, formData, null);
      
      showSuccess(t("sucessfullySavedLabel"));
      setLoading(false);
      
    } catch (error) {
      setLoading(false);
      showError(t("somethingWrongLabel"));

    }
  }

  useEffect(() => {
    const config = gatewayConfig?.[channel];
    const updatedFormValues: any = {
        username :config?.username ,
        endpoint : config?.endpoint,
        authkey : config?.authkey,
        field : config?.field,
        expiration : config?.expiration,
       }
   form.setFieldsValue(updatedFormValues);
  },[ channel, form])
  

  return (
    <Fragment>
      <div className="gateway-notification-container">
        <div className="mt-4 mb-4  ">
          <h6 className="gateway-notification-container-heading">
            {t("gatewayLabel")} 
          </h6>
          <Divider className="gateway-notification-custom-divider" />
        </div>

        <div className=" col-sm-7 mt-4 mb-4 align-items-center gateway-notification-form ">
          
          {loading ? (
            <Spinner />
          ) : (
            <Form
              form={form}
              layout="horizontal"
              onFinish={onFormSubmit}
            >
              <Form.Item
                     label={t("selectChannelLabel")}
                  >
                    <Selector
                     onChange={(value: string) => {
                        setChannel(value)
                     }
                       
                    }
       options={channelOptions}
                     value={channel}
                    />
              </Form.Item>
{channel &&<>              <Form.Item
                label={t("endpointLabel")}
                name={"endpoint"}
                rules={[
                  { required: true },
                ]}
                initialValue={""}
              >
                <TextInput
                    />
              </Form.Item>


            
              <Form.Item
                label={t("usernameLabel")}
                 name={"username"}
                rules={[
                  { required: true},
                ]}
                initialValue={""}
              >
                <TextInput />
              </Form.Item>
              <Form.Item
                label={t("authKeyLabel")}
                name={"authkey"}
                rules={[
                  { required: true },
                ]}
                initialValue={""}
              >
                <TextInput />
              </Form.Item>
              <Form.Item
                label={t("fieldLabel")}
                name={"field"}
                rules={[
                  { required: true },
                ]}
                initialValue={""}
              >
                <TextInput 
                type="string" 
                />
              </Form.Item>
              <Form.Item
                label={t("expirationLabel")}
                name={"expiration"}
                rules={[
                  { required: true },
                ]}
              >
                <TextInput type="number" />
              </Form.Item>
              </>}

           
              <div className="">
                <PrimaryButton
                  size="middle"
                  type="primary"
                  htmlType="submit"
                >
                  {t("saveLabel")}
                </PrimaryButton>
              </div>
            </Form>
          )}
        </div>
      </div>
    </Fragment>
  );
};
export default Gateway;
